export default __webpack_public_path__ + "static/article-finance-a-better-family-car-534f459a2a3e627debd5f7d59fe6b5df.jpg";